import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import { i as isEmpty } from './utils-15ad90ec.js';
import { a as switchProductSelector } from './product-selector-utils-92375719.js';
import './request.constants-deb285e0.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './_commonjsHelpers-ba3f0406.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './types-aae419ee.js';

const productSelectorModalCss$1 = "#widgetFrame{display:flex;height:100%}se-dialog-content{display:flex;flex:1}.sc-selector-modal-header{display:flex;justify-content:space-between;align-items:flex-start;padding:20px 15px 10px}.sc-selector-modal-controls{display:flex}.sc-selector-modal-controls pes-icon{cursor:pointer}.header-label{font-size:2em;font-weight:400;line-height:1.5em;margin:0}:host(:not([dir=\"rtl\"])) .header-label{padding-right:30px}:host([dir=\"rtl\"]) .header-label{padding-left:30px}.header-label .highlight-naming{font-weight:400}.header-label .highlight-naming .accent{font-weight:700}expand-button{display:none}.button-close{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit}.icon-close{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E\");height:18px;width:18px}@media only screen and (max-width: 979px){#iframeWidget{border:none;border-top:2px solid #3dcd58}}@media screen and (min-width: 980px){.header-label{font-size:35px}expand-button{display:block;cursor:pointer;color:#9fa0a4}:host(:not([dir=\"rtl\"])) expand-button{border-right:1px solid;margin-right:16px;padding-right:16px}:host([dir=\"rtl\"]) expand-button{border-left:1px solid;margin-left:16px;padding-left:16px}.sc-selector-modal-header{padding-bottom:0}}";

let ExpandButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.expandModal = createEvent(this, "expandModal", 7);
    this.isFullscreen = false;
  }
  todoCompletedHandler() {
    this.expandModal.emit();
  }
  render() {
    return (h("pes-icon", { customStyle: { fontSize: '19px' } }, this.isFullscreen ? 'exit_presentation' : 'presentation_mode'));
  }
};
ExpandButton.style = productSelectorModalCss$1;

const productSelectorModalCss = "#widgetFrame{display:flex;height:100%}se-dialog-content{display:flex;flex:1}.sc-selector-modal-header{display:flex;justify-content:space-between;align-items:flex-start;padding:20px 15px 10px}.sc-selector-modal-controls{display:flex}.sc-selector-modal-controls pes-icon{cursor:pointer}.header-label{font-size:2em;font-weight:400;line-height:1.5em;margin:0}:host(:not([dir=\"rtl\"])) .header-label{padding-right:30px}:host([dir=\"rtl\"]) .header-label{padding-left:30px}.header-label .highlight-naming{font-weight:400}.header-label .highlight-naming .accent{font-weight:700}expand-button{display:none}.button-close{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit}.icon-close{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E\");height:18px;width:18px}@media only screen and (max-width: 979px){#iframeWidget{border:none;border-top:2px solid #3dcd58}}@media screen and (min-width: 980px){.header-label{font-size:35px}expand-button{display:block;cursor:pointer;color:#9fa0a4}:host(:not([dir=\"rtl\"])) expand-button{border-right:1px solid;margin-right:16px;padding-right:16px}:host([dir=\"rtl\"]) expand-button{border-left:1px solid;margin-left:16px;padding-left:16px}.sc-selector-modal-header{padding-bottom:0}}";

let ProductSelectorModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didClose = createEvent(this, "didClose", 7);
    this.open = false;
    this.isFullscreen = false;
    this.handleCloseButtonClick = () => {
      this.didClose.emit();
    };
  }
  handleFullscreenToggle() {
    this.isFullscreen = !this.isFullscreen;
    if (this.isFullscreen) {
      this.setFullscreenStyles();
    }
    else {
      this.setDefaultStyles();
    }
  }
  isMobile() {
    return window.innerWidth <= 980;
  }
  setDefaultStyles() {
    const innerContent = this.element
      .querySelector('se-dialog-content')
      .shadowRoot.querySelector('.se-dialog-content');
    innerContent.style.padding = '5px 20px 20px 20px';
    innerContent.style.alignItems = 'stretch';
    const innerContentMarginDiv = innerContent.querySelector('.inner-content');
    innerContentMarginDiv.style.margin = '0';
    const quartzModalBackdropElement = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-background');
    quartzModalBackdropElement.style.backgroundColor = 'rgba(0,0,0,.4)';
    const quartzModalContainer = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog');
    quartzModalContainer.style.height = '80%';
    quartzModalContainer.style.width = '80%';
    const quartzModalDialogBodyInner = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-body-inner');
    quartzModalDialogBodyInner.style.height = '100%';
  }
  setMobileOffset() {
    const quartzModalContainer = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog-wrapper');
    quartzModalContainer.style.margin = '5px';
    const innerContent = this.element
      .querySelector('se-dialog-content')
      .shadowRoot.querySelector('.se-dialog-content');
    innerContent.style.padding = '5px 0 0 0';
  }
  setFullscreenStyles() {
    const dialog = this.element
      .querySelector('se-dialog')
      .shadowRoot.querySelector('.dialog');
    dialog.style.height = '100%';
    dialog.style.width = '100%';
  }
  getSize() {
    if (this.isFullscreen || this.isMobile()) {
      return 'fill';
    }
    return 'large';
  }
  renderFullscreenControls() {
    return h("expand-button", { isFullscreen: this.isFullscreen });
  }
  renderCloseModalControls() {
    return (h("button", { type: "button", class: "button-close", onClick: this.handleCloseButtonClick }, h("div", { class: "icon-close" })));
  }
  componentDidLoad() {
    this.setDefaultStyles();
    if (this.isMobile()) {
      this.setFullscreenStyles();
      this.setMobileOffset();
    }
  }
  render() {
    return (h("se-dialog", { size: this.getSize(), open: this.open, noBackdrop: "true" }, h("div", { class: "sc-selector-modal-header" }, h("h1", { class: "header-label", innerHTML: this.headerLabel }), h("div", { class: "sc-selector-modal-controls" }, this.renderFullscreenControls(), this.renderCloseModalControls())), h("se-dialog-content", null, h("slot", null))));
  }
  get element() { return getElement(this); }
};
ProductSelectorModal.style = productSelectorModalCss;

const productSelectorCss = ".product-selector-link{cursor:pointer;display:flex;align-items:center;font-weight:400;font-size:14px;color:#42b4e6;padding-top:0;margin-top:15px}:host(:not([dir=\"rtl\"])) .product-selector-link{padding-left:75px}:host([dir=\"rtl\"]) .product-selector-link{padding-right:75px}.product-selector-link pes-icon{position:relative}.product-selector-link pes-icon:hover{text-decoration:none}@media screen and (min-width: 980px){.product-selector-link pes-icon{text-decoration:none}}@media screen and (min-width: 980px){.product-selector-link{margin-top:10px}:host(:not([dir=\"rtl\"])) .product-selector-link{padding-left:0;margin-left:0}:host([dir=\"rtl\"]) .product-selector-link{padding-right:0;margin-right:0}}.product-selector-btn{box-sizing:border-box;width:100%;margin-top:16px;background-color:#42b4e6;border:none;padding:10px 20px;color:#ffffff;font-size:16px;line-height:20px;outline:none;cursor:pointer;font-weight:400}.product-selector-btn *,.product-selector-btn *::before,.product-selector-btn *::after{box-sizing:inherit}:host(:not([dir=\"rtl\"])) .product-selector-btn:hover{background:linear-gradient(180deg, #55d1fe, #42b4e6)}:host([dir=\"rtl\"]) .product-selector-btn:hover{background:linear-gradient(-180deg, #55d1fe, #42b4e6)}.product-selector-btn:active{background:#3a738c}@media screen and (min-width: 980px){.product-selector-btn{width:auto}}:host(:not([dir=\"rtl\"]).sub) .product-selector-link{padding-left:0}:host([dir=\"rtl\"].sub) .product-selector-link{padding-right:0}";

let ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.openingProductSelector = createEvent(this, "openingProductSelector", 7);
  }
  openPesProductSelector(config) {
    if (this.selector) {
      this.openingProductSelector.emit(config);
      this.selector.open(config);
    }
    else {
      console.error("Selector wasn't inited");
    }
  }
  componentWillLoad() {
    if (this.config) {
      const productSelector = switchProductSelector(this.config);
      if (productSelector) {
        productSelector.then((selector) => {
          this.selector = selector;
        });
      }
    }
  }
  render() {
    if (isEmpty(this.config)) {
      return null;
    }
    return this.renderFunction(this.selector);
  }
};
ProductSelector.style = productSelectorCss;

export { ExpandButton as expand_button, ProductSelectorModal as pdp_sc_selector_modal, ProductSelector as pes_product_selector };
